import { HashRouter, Route, Routes } from "react-router-dom";
import NotFound from "../pages/NotFound";
import PrivateRoute from "./privateRoute";
import { routes } from "./routes";
import PublicRoute from "./publicRoute";
import RecaptchaLayout from "./RecaptchaLayout";

const Router = () => {
  return (
    <HashRouter basename="/">
      <Routes>
        {/* General Routes */}

        <Route element={<PublicRoute />}>
          {/* Auth routes share the reCAPTCHA provider so the script loads once
              and stays mounted across auth-page navigation. Scoped via the
              `auth` flag in routes.tsx — not other public pages or the dashboard. */}
          <Route element={<RecaptchaLayout />}>
            {routes.map(
              (route) =>
                !route.protected &&
                route.auth && (
                  <Route
                    path={route.path}
                    element={<route.element />}
                    key={route.path}
                  />
                ),
            )}
          </Route>
          {/* Other public routes (no reCAPTCHA) */}
          {routes.map(
            (route) =>
              !route.protected &&
              !route.auth && (
                <Route
                  path={route.path}
                  element={<route.element />}
                  key={route.path}
                />
              ),
          )}
        </Route>
        {/* Privte Routes */}
        <Route element={<PrivateRoute />}>
          {routes.map(
            (route) =>
              route.protected && (
                <Route
                  path={route.path}
                  element={<route.element />}
                  key={route.path}
                />
              ),
          )}
        </Route>

        {/* Catch routes */}
        <Route path="*" element={<NotFound />} key="Error404" />
      </Routes>
    </HashRouter>
  );
};

export default Router;
